function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CalendarMonth from "react-dates/esm/components/CalendarMonth";
import CalendarDay from "react-dates/esm/components/CalendarDay";
import { BLOCKED_MODIFIER } from "react-dates/esm/constants";
import moment from 'moment';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { Dropdown } from "../../inputs/Dropdown";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { GridRow } from "../../layout/GridRow";
import { Heading } from "../../typography/Heading";
import { Icon, ICON_NAMES } from "../../elements/Icon";
import { Paragraph } from "../../typography/Paragraph";
import { withResponsive } from "../../../utils/with-responsive";
import { AVAILABILITY, NEXT, PREVIOUS, PROPERTIES, UNAVAILABLE, VIEW_AVAILABILITY_FOR } from "../../../utils/default-strings";
import { BLOCKED_DAY_CLASS } from "./constants";
import { isDayBlockedOrBeforeCurrentDate } from "./utils/isDayBlockedOrBeforeCurrentDate";
import { getMonthsToDisplay } from "./utils/getMonthsToDisplay";
import { getNextStartDate } from "./utils/getNextStartDate";
import { getPreviousStartDate } from "./utils/getPreviousStartDate";
import { renderMonthHeader } from "./utils/renderMonthHeader";
import "react-dates/esm/initialize";

var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      startDate: moment()
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickNextMonth", function () {
      return _this.setState({
        startDate: getNextStartDate(_this.state.startDate, _this.props.isUserOnMobile)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickPreviousMonth", function () {
      return _this.setState({
        startDate: getPreviousStartDate(_this.state.startDate, _this.props.isUserOnMobile)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCalendarDay", function (props) {
      var modifiers = new Set([]);
      var getIsDayBlocked = _this.props.getIsDayBlocked;

      if (isDayBlockedOrBeforeCurrentDate(props.day, getIsDayBlocked)) {
        modifiers.add(BLOCKED_DAY_CLASS);
        modifiers.add(BLOCKED_MODIFIER);
      }

      return React.createElement(CalendarDay, _extends({}, props, {
        modifiers: modifiers
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "reloadCalendarOnRoomSelection", function (evt, value) {
      _this.props.onChangeRoomDropdown(evt, value);

      _this.forceUpdate();
    });

    return _this;
  }

  _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var startDate = this.state.startDate;
      var _this$props = this.props,
          id = _this$props.id,
          headingText = _this$props.headingText,
          isUserOnMobile = _this$props.isUserOnMobile,
          legendLabel = _this$props.legendLabel,
          nextMonthsButtonLabel = _this$props.nextMonthsButtonLabel,
          previousMonthsButtonLabel = _this$props.previousMonthsButtonLabel,
          propertyDropdownLabel = _this$props.propertyDropdownLabel,
          propertyDropdownPlaceholderLabel = _this$props.propertyDropdownPlaceholderLabel,
          roomOptionsValue = _this$props.roomOptionsValue,
          roomOptionsWithImages = _this$props.roomOptionsWithImages;
      moment.locale(this.props.localeCode);
      return React.createElement("div", {
        id: id
      }, React.createElement(Heading, {
        size: "medium"
      }, headingText), React.createElement(Grid, null, React.createElement(GridRow, null, roomOptionsWithImages && React.createElement(GridColumn, {
        computer: 7,
        mobile: 12,
        tablet: 6,
        verticalAlignContent: "middle"
      }, React.createElement(Grid, null, React.createElement(GridColumn, {
        computer: 3,
        mobile: 5,
        tablet: 12,
        verticalAlignContent: "middle"
      }, React.createElement(Paragraph, {
        size: "tiny",
        weight: "heavy"
      }, propertyDropdownLabel)), React.createElement(GridColumn, {
        computer: 7,
        mobile: 7,
        tablet: 12
      }, React.createElement(Dropdown, {
        icon: ICON_NAMES.MAP_PIN,
        isClearable: false,
        label: propertyDropdownPlaceholderLabel,
        onChange: this.reloadCalendarOnRoomSelection,
        options: roomOptionsWithImages,
        value: roomOptionsValue
      })))), React.createElement(GridColumn, {
        floated: "right",
        only: "tablet computer",
        textAlign: "right",
        verticalAlignContent: "middle",
        width: 5
      }, React.createElement(Icon, {
        color: "light grey",
        isLabelLeft: true,
        labelText: legendLabel,
        name: ICON_NAMES.SQUARE
      })))), React.createElement(Card, {
        fluid: true
      }, React.createElement(Grid, {
        padded: true
      }, React.createElement(GridRow, null, getMonthsToDisplay(startDate, isUserOnMobile).map(function (month, index) {
        return React.createElement(GridColumn, {
          className: "availability-calendar-wrapper",
          computer: 6,
          key: buildKeyFromStrings('month-column', index),
          mobile: 12,
          tablet: 6
        }, React.createElement(CalendarMonth, {
          isVisible: true,
          month: month,
          renderCalendarDay: _this2.renderCalendarDay,
          renderMonthElement: renderMonthHeader(_this2.props.localeCode)
        }));
      })), React.createElement(GridRow, null, React.createElement(GridColumn, {
        width: 6
      }, React.createElement(Icon, {
        isButton: true,
        labelText: previousMonthsButtonLabel,
        name: ICON_NAMES.ARROW_LEFT,
        onClick: this.handleClickPreviousMonth
      })), React.createElement(GridColumn, {
        textAlign: "right",
        width: 6
      }, React.createElement(Icon, {
        isButton: true,
        isLabelLeft: true,
        labelText: nextMonthsButtonLabel,
        name: ICON_NAMES.ARROW_RIGHT,
        onClick: this.handleClickNextMonth
      }))))), React.createElement(Grid, null, React.createElement(GridColumn, {
        only: "mobile",
        textAlign: "right",
        width: 12
      }, React.createElement(GridColumn, null, React.createElement(Icon, {
        color: "light grey",
        isLabelLeft: true,
        labelText: legendLabel,
        name: ICON_NAMES.SQUARE
      })))));
    }
  }]);

  return Component;
}(PureComponent);

export var ComponentWithResponsive = withResponsive(Component);
Component.displayName = 'Availability';
Component.defaultProps = {
  id: null,
  getIsDayBlocked: function getIsDayBlocked() {
    return false;
  },
  headingText: AVAILABILITY,
  legendLabel: UNAVAILABLE,
  localeCode: 'en',
  nextMonthsButtonLabel: NEXT,
  onChangeRoomDropdown: Function.prototype,
  previousMonthsButtonLabel: PREVIOUS,
  propertyDropdownLabel: VIEW_AVAILABILITY_FOR,
  propertyDropdownPlaceholderLabel: PROPERTIES,
  roomOptionsValue: undefined,
  roomOptionsWithImages: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  getIsDayBlocked: PropTypes.func,
  headingText: PropTypes.string,
  id: PropTypes.string,
  isUserOnMobile: PropTypes.bool.isRequired,
  legendLabel: PropTypes.string,
  localeCode: PropTypes.string,
  nextMonthsButtonLabel: PropTypes.string,
  onChangeRoomDropdown: PropTypes.func,
  previousMonthsButtonLabel: PropTypes.string,
  propertyDropdownLabel: PropTypes.string,
  propertyDropdownPlaceholderLabel: PropTypes.string,
  roomOptionsValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  roomOptionsWithImages: PropTypes.PropTypes.arrayOf(PropTypes.shape({
    imageSizes: PropTypes.string,
    imageSrcSet: PropTypes.string,
    imageUrl: PropTypes.string,
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  }))
} : {};